import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingOverallRating } from '../../components/NewbuildingOverallRating';
import { getNewbuildingInfo } from '../../selectors/newbuildingInfo';

export function NewbuildingOverallRatingContainer(): React.JSX.Element {
  const { rating, newbuildingNameFormatted, reviewsCount } = useSelector(getNewbuildingInfo);

  return (
    <NewbuildingOverallRating
      value={rating}
      newbuildingNameFormatted={newbuildingNameFormatted}
      reviewCount={reviewsCount}
    />
  );
}
